<div class="container">
  <mat-card>
    <img src="../../assets/kofc-logo.jpg">
  </mat-card>
</div>
